import Swiper from "swiper";
import {Navigation, Pagination} from "swiper/modules";

export class Slider {

    constructor() {
        this.init();
    }

    init() {
        new Swiper('.js-slider', {
            modules: [Pagination, Navigation],
            loop: false,
            speed: 500,
            navigation: {
                nextEl: '.slider-button-next',
                prevEl: '.slider-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    }
}
